import { formatBytes } from "../../lib/formatBytes";
import type { StatusSegment } from "../StatusBreakdownChart";
import { splitBySharePrefix } from "./foldSegments";

export const OTHER_KEY = "__other__";

// A space earns its own tile only if it's a big enough share of the total to
// render legibly; smaller ones fold into "Other". MAX_TILES caps a pathological
// number of near-threshold spaces.
const MIN_SHARE = 0.06;
const MAX_TILES = 12;

export type StorageRow = { id: string; label: string; bytes: number };

export function buildStorageSegments(
  rows: readonly StorageRow[],
  totalBytes: number,
  colorMap: ReadonlyMap<string, string>
): StatusSegment[] {
  const { kept, folded } = splitBySharePrefix(
    rows,
    (r) => r.bytes,
    totalBytes,
    {
      minShare: MIN_SHARE,
      maxKept: MAX_TILES - 1,
    }
  );
  const segments: StatusSegment[] = kept.map((row) => ({
    key: row.id,
    count: row.bytes,
    color: colorMap.get(row.id)!,
    label: row.label,
  }));
  if (folded.length > 0) {
    segments.push({
      key: OTHER_KEY,
      count: folded.reduce((sum, row) => sum + row.bytes, 0),
      color: "var(--gray-600)",
      label: `${folded.length} more spaces`,
      details: folded.map((row) => ({
        label: row.label,
        value: formatBytes(row.bytes),
      })),
    });
  }
  return segments;
}
